import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "left-align" }
const _hoisted_4 = { class: "right-align" }
const _hoisted_5 = { class: "emq-table-footer" }

import { ref, computed, watch } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import {
  getHlhtAuthList,
  syncHlhtAuthConfig,
  hlhtRefreshToken,
  cacheHlhtAuthConfig,
  deleteHlhtAuthConfig,
  pushHlhtAuthsToTP,
} from '@/api/operation'
import { pick } from 'lodash'
import CommonPagination from '@/components/commonPagination.vue'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { dateFormat } from '@/common/tools'
import { ADOType } from '@/types/types'
import { ElMessage, ElMessageBox } from 'element-plus'
import HlhtAuthAdd from './HlhtAuthAdd.vue'
import { HLHTProtocol } from '@/types/types'
import LinkStation from '@/components/Links/LinkStation.vue'


import { defineComponent } from 'vue'
import { info } from '@/api/common'

const __default__ = defineComponent({
  name: 'HlhtAuths',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  info: {
    // config info
    type: Object,
    default() {
      return {}
    },
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { emit }) {

const props = __props


const { tl, t } = useI18nTl('Operation')

const showAuthDialog = ref(false)

const adoSelect = ref(ADOType.ADOT_OPERATOR)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('Hlhts-detail')



const showDialog = computed({
  get: () => {
    return props.modelValue
  },
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const refreshToken = async () => {
  try {
    await ElMessageBox.confirm(t('Operation.confirmRefreshToken'), {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })
    await hlhtRefreshToken({ configId: props.info.id })
    ElMessage.success(t('Base.opSuccess'))
  } catch (error) {
    console.error(error)
  }
}

const addHlht = () => {
  showAuthDialog.value = true
}

const pushHlhtAuths = async () => {
  await ElMessageBox.confirm(t('Operation.confirmPush'), {
    confirmButtonText: t('Base.confirm'),
    cancelButtonText: t('Base.cancel'),
    confirmButtonClass: 'confirm-danger',
    type: 'warning',
  })

  pushHlhtAuthsToTP({ id: props.info.id })
    .then((res: any) => {
      ElMessage.success(t(`Base.opSuccess`))
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}

const cacheHlht = () => {
  cacheHlhtAuthConfig({ configId: props.info.id })
    .then((res: any) => {
      ElMessage.success(t(`Base.opSuccess`))
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}
const syncAuth = (auth: any) => {
  syncHlhtAuthConfig({ configId: props.info.id, authAdoId: auth.ADOID })
    .then((res: any) => {
      ElMessage.success(t(`Base.opSuccess`))
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}

const deleteAuth = (auth: any) => {
  deleteHlhtAuthConfig({ authId: auth.ID })
    .then((res: any) => {
      ElMessage.success(t(`Base.opSuccess`))
      loadTableData()
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
    configId: props.info?.id,
    adoType: adoSelect.value,
  }

  try {
    const { list = [], pageReply = {} } = await getHlhtAuthList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

watch(adoSelect, async (val) => {
  loadTableData()
})

watch(
  () => props.info,
  (newVal) => {
    if (newVal.id != '0') {
      loadTableData()
    }
  },
)

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _unref(t)('Operation.hlhtAuthList'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "60%",
    "z-index": 1999,
    "custom-class": "evse-drawer",
    "destroy-on-close": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_radio_group, {
              class: "legend-select",
              modelValue: adoSelect.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((adoSelect).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: _unref(ADOType).ADOT_OPERATOR
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Operation.operator')), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_radio_button, {
                  label: _unref(ADOType).ADOT_STATION
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Operation.station')), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (addHlht()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.use')), 1)
              ]),
              _: 1
            })), [
              [_directive_role, 'hlhtAuthOP']
            ]),
            _createVNode(_component_el_tooltip, {
              content: _ctx.$t('Operation.hlhtCacheTip'),
              placement: "top"
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (cacheHlht()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.cache')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_role, 'hlhtAuthOP']
                ])
              ]),
              _: 1
            }, 8, ["content"]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              plain: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (refreshToken()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Operation.refreshToken')), 1)
              ]),
              _: 1
            })), [
              [_directive_role, 'hlhtUpsert']
            ]),
            (props.info.proto == _unref(HLHTProtocol).HP_AMAP)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: _ctx.$t('Operation.hlhtPushAllTip'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      type: "primary",
                      plain: "",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (pushHlhtAuths()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.push')), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_role, 'hlhtAuthOP']
                    ])
                  ]),
                  _: 1
                }, 8, ["content"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          ref_key: "TableCom",
          ref: TableCom,
          "row-key": "id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "ID",
              "min-width": "100",
              label: _ctx.$t('Base.id'),
              align: "center"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "ADOName",
              "min-width": "100",
              label: _ctx.$t('Base.name')
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(LinkStation, {
                  id: row.ADOID,
                  name: row.ADOName
                }, null, 8, ["id", "name"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              "min-width": "100",
              label: _ctx.$t('Base.usedAt')
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.CreatedAt) * 1000)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('Base.operation'),
              "class-name": "table-operation"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tooltip, {
                  content: _ctx.$t('Operation.hlhtSyncTip'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    (row.ADO == _unref(ADOType).ADOT_OPERATOR)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          size: "small",
                          plain: "",
                          onClick: ($event: any) => (syncAuth(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('Base.sync')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["content"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  plain: "",
                  onClick: ($event: any) => (deleteAuth(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [
            _directive_loading,
            lockTable.value,
            void 0,
            { lock: true }
          ]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(CommonPagination, {
            metaData: _unref(pageMeta),
            "onUpdate:metaData": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
            onLoadPage: loadTableData
          }, null, 8, ["metaData"])
        ]),
        _createVNode(HlhtAuthAdd, {
          modelValue: showAuthDialog.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showAuthDialog).value = $event)),
          info: props.info,
          onSubmitted: loadTableData
        }, null, 8, ["modelValue", "info"])
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})